export default __webpack_public_path__ + "static/media/homem.16b75de3.png";